"use client";

import Link from 'next/link';
import { useCartStore } from '../store/cartStore';

export default function Header() {
  const cartItems = useCartStore((state) => state.items);
  const totalItems = cartItems.reduce((sum, item) => sum + item.quantity, 0);

  return (
    <header className="bg-[#000f1e]/95 backdrop-blur-xl border-b border-white/10 sticky top-0 z-50 py-2.5">
      <div className="max-w-[1320px] mx-auto px-5 flex flex-col md:flex-row justify-between items-center gap-5">
        
        {/* Логотип */}
        <Link href="/" className="hover:scale-105 transition-transform">
          <div className="h-[60px] md:h-[80px] flex items-center text-2xl font-black text-[#ff6600]">
            AUTO<span className="text-white">LOGISTIC</span>
          </div>
        </Link>

        {/* Навігація */}
        <nav className="hidden lg:flex items-center gap-2 bg-white/5 px-4 py-2 rounded-full border border-white/5">
          <Link href="/" className="text-[#ccc] hover:text-white hover:bg-white/10 font-semibold text-[13px] uppercase tracking-wide px-4 py-2 rounded-full transition-all">Головна</Link>
          <Link href="/about" className="text-[#ccc] hover:text-white hover:bg-white/10 font-semibold text-[13px] uppercase tracking-wide px-4 py-2 rounded-full transition-all">Про нас</Link>
          <Link href="/delivery" className="text-[#ccc] hover:text-white hover:bg-white/10 font-semibold text-[13px] uppercase tracking-wide px-4 py-2 rounded-full transition-all">Оплата і доставка</Link>
          
          {/* Випадаюче меню для додаткових сторінок */}
          <div className="relative group">
            <button className="text-[#ccc] group-hover:text-white group-hover:bg-white/10 font-semibold text-[13px] uppercase tracking-wide px-4 py-2 rounded-full transition-all flex items-center gap-1">
              Клієнтам
              <svg className="w-4 h-4 transition-transform group-hover:rotate-180" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7"></path></svg>
            </button>
            <div className="absolute top-full left-0 mt-2 w-56 bg-white rounded-xl shadow-xl border border-gray-100 opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200 transform origin-top-left group-hover:translate-y-0 translate-y-2">
              <div className="py-2 flex flex-col">
                <Link href="/returns" className="px-4 py-2.5 text-sm text-gray-700 hover:bg-blue-50 hover:text-blue-700 font-medium transition-colors">Обмін та повернення</Link>
                <Link href="/terms" className="px-4 py-2.5 text-sm text-gray-700 hover:bg-blue-50 hover:text-blue-700 font-medium transition-colors">Угода користувача</Link>
                <Link href="/privacy" className="px-4 py-2.5 text-sm text-gray-700 hover:bg-blue-50 hover:text-blue-700 font-medium transition-colors">Політика конфіденційності</Link>
              </div>
            </div>
          </div>

          <Link href="/contacts" className="text-[#ccc] hover:text-white hover:bg-white/10 font-semibold text-[13px] uppercase tracking-wide px-4 py-2 rounded-full transition-all">Контакти</Link>
        </nav>

        {/* Контакти та Кошик */}
        <div className="flex flex-col md:flex-row items-center gap-7">
          <div className="flex flex-col items-end gap-0.5">
            <a href="tel:+380639509000" className="flex flex-col items-end group text-white decoration-transparent">
              <span className="font-extrabold text-xl tracking-wide group-hover:text-[#ff6600] transition-colors">+38 063 950-9000</span>
              <span className="text-[11px] text-[#aaa] uppercase tracking-wider">Щоденно 09:00 - 19:00</span>
            </a>
            <a href="mailto:anatoliy@autologistic.com.ua" className="text-[#ff6600] text-[13px] font-medium hover:text-white hover:underline transition-colors flex items-center gap-1.5 mt-1">
              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path><polyline points="22,6 12,13 2,6"></polyline></svg>
              anatoliy@autologistic.com.ua
            </a>
          </div>

          <Link href="/cart" className="bg-gradient-to-br from-[#ff6600] to-[#ff4500] hover:-translate-y-0.5 text-white px-6 py-3 rounded-full font-bold flex items-center gap-2.5 transition-all shadow-[0_4px_15px_rgba(255,69,0,0.3)] hover:shadow-[0_6px_25px_rgba(255,69,0,0.5)] border border-white/10 relative">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="9" cy="21" r="1"></circle><circle cx="20" cy="21" r="1"></circle><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path></svg>
            Кошик
            {totalItems > 0 && (
              <span className="absolute -top-2 -right-2 bg-white text-[#ff6600] text-xs font-black px-2.5 py-0.5 rounded-full shadow-md">
                {totalItems}
              </span>
            )}
          </Link>
        </div>
      </div>
    </header>
  );
}
